import React, { useEffect, useState } from "react";

import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../../hooks/useLocalStorage";
import Button from "@mui/material/Button";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";

import {ReactComponent as CheckCircleIcon} from "../../../icons/CheckCircle24.svg";
import {ReactComponent as ErrorIcon} from "../../../icons/Error24.svg";

import DrawerAppBar from "../../../components/DrawerAppBar";
import Title from "../../../components/Title";
import ProgressBar from "../../../components/ProgressBar";

import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";

import { doService } from "../../../services/ServiceHelper";
import {
  getSchoolActivityDates,
  cloneSchoolActivityDates,
} from "../../../services/ActivityService";

import TableRowNoResults from "../../../components/TableRowNoResults";
import { getPeriodName } from "../../../services/SchoolService";

import {
  showError,
  showOKCancelDialog,
  showToast,
} from "../../../components/ATPDialogs";

import { runHealthCheck } from "../../../services/AdminService";

import {
  StripedTableCell,
  StripedTableRow,
} from "../../../components/StripedTable";
import clone from "lodash-es/clone";

const HealthCheck = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_results, setResults] = useState([]);
  const [_checks, setChecks] = useState([
    { id: "databasew", name: "Database (writable)", checked: false },
    { id: "databaser", name: "Database (readable)", checked: false },
    { id: "dynamow", name: "Dynamo Write", checked: false },
    { id: "queuew", name: "Queue Write", checked: false },
    { id: "email", name: "Email", checked: false },
    { id: "cache", name: "Cache", checked: false },
  ]);

  useEffect(() => {}, []);

  const runCheck = (item) => {
    setShowProgress(true);
    doService(runHealthCheck(_school, _jwt, item.id), (results) => {
      setShowProgress(false);
      if (results.detail) {
        item.result = "FAIL";
        showError("Failed Check for " + item.name, results.detail);
        return;
      }
      item.result = "OK";
      showToast("S", "Successful Check for " + item.name);
    });
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Health Check" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small" sx={{ mb: 2 }}>
            <TableHead>
              <StripedTableRow>
                <StripedTableCell>Item</StripedTableCell>
                <StripedTableCell align="center">Result</StripedTableCell>
                <StripedTableCell align="center" width={160}>
                  Action
                </StripedTableCell>
              </StripedTableRow>
            </TableHead>
            <TableBody>
              {_checks.map((result) => (
                <StripedTableRow>
                  <StripedTableCell>{result.name}</StripedTableCell>
                  <StripedTableCell align="center">
                    {result.result === "OK" && <CheckCircleIcon color="success"/>}
                    {result.result === "FAIL" && <ErrorIcon color="error" />}
                  </StripedTableCell>
                  <StripedTableCell align="center">
                    <Button
                      variant="contained"
                      onClick={() => runCheck(result)}
                    >
                      Run Check
                    </Button>
                  </StripedTableCell>
                </StripedTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

export default HealthCheck;
